module.exports = __webpack_public_path__ + "img/giveaway.014fb126.jpeg";